import moment from 'moment';
import firebase from 'firebase';
import {
  ADD_TO_INVOICE,
  CLEAR_INVOICE,
  COUNT_INVOICE_TOTALS,
  REMOVE_INVOICE_ITEM,
  TOGGLE_INVOICE_ITEM_AMOUNT
} from '../actions';

const invoiceReducer = (state, action) => {
  if (action.type === ADD_TO_INVOICE) {
    const { productID, productName, units, sellingPrice, total } = action.payload;
    // const tempItem = state.invoice.find(
    //   (i) => i.id === product.pid + color.substring(1) + size.trim()
    // );
    // if (tempItem) {
    //   const tempInvoice = state.invoice.map((invoiceItem) => {
    //     if (invoiceItem.id === product.pid + color.substring(1) + size.trim()) {
    //       let newAmount = invoiceItem.amount + amount;
    //       if (newAmount > invoiceItem.max) {
    //         newAmount = invoiceItem.max;
    //       }

    //       return { ...invoiceItem, amount: newAmount };
    //     }
    //     return invoiceItem;
    //   });

    //     return { ...state, invoice: currentInvoice };
    //   }

    const newItem = {
      productID,
      productName,
      units,
      sellingPrice,
      total
    };

    return { ...state, invoice: [...state.invoice, newItem] };
  }
  // if (action.type === REMOVE_CART_ITEM) {
  //   const tempCart = state.cart.filter((item) => item.id !== action.payload)
  //   firebase.database().ref('CartInfo/UserView').child('0662500858').child('Products').child(action.payload).remove()
  //   return { ...state, cart: tempCart }
  // }
  // if (action.type === CLEAR_CART) {
  //   firebase.database().ref('CartInfo/UserView').child('0662500858').remove()
  //   return { ...state, cart: [] }
  // }
  // if (action.type === TOGGLE_CART_ITEM_AMOUNT) {
  //   const { id, value } = action.payload
  //   const tempCart = state.cart.map((item) => {
  //     if (item.id === id) {
  //       if (value === 'inc') {
  //         let newAmount = item.amount + 1
  //         if (newAmount > item.max) {
  //           newAmount = item.max
  //         }
  //         let userRefs = firebase.database().ref('CartInfo/UserView').child('0662500858').child('Products')
  //         userRefs.child(id).update({'quantity': newAmount})
  //         return { ...item, amount: newAmount }
  //       }
  //       if (value === 'dec') {
  //         let newAmount = item.amount - 1
  //         if (newAmount < 1) {
  //           newAmount = 1
  //         }
  //         let userRef = firebase.database().ref('CartInfo/UserView').child('0662500858').child('Products')
  //         userRef.child(id).update({'quantity': newAmount})
  //         return { ...item, amount: newAmount }
  //       }
  //     } else {
  //       return item
  //     }
  //   })

  //   return { ...state, cart: tempCart }
  // }
  if (action.type === COUNT_INVOICE_TOTALS) {
    const { totalItems, totalAmount } = state.invoice.reduce(
      (total, invoiceItem) => {
        console.log('invoice Item in reducer', invoiceItem);
        const { units, sellingPrice } = invoiceItem;

        total.totalItems += units;
        total.totalAmount += units * sellingPrice;
        return total;
      },
      {
        totalItems: 0,
        totalAmount: 0
      }
    );
    return { ...state, totalItems, totalAmount };
  }
  // throw new Error(`No Matching "${action.type}" - action type`)
};

export default invoiceReducer;
